var _linearGradient, _linearGradient2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiswap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 25.6089,
    x2: 21.8342,
    y1: 10.2099,
    y2: 31.0052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff496a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e42648"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 7.72271,
    x2: 16.0686,
    y1: 23.5689,
    y2: -0.000006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00181229,
    stopColor: "#1158f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119bed"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 31.9999c8.8365 0 16-7.1634 16-15.9999 0-8.83657-7.1635-16-16-16-8.83656 0-16 7.16343-16 16 0 8.8365 7.16344 15.9999 16 15.9999z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.3937 6.01932c-1.1097.21935-2.1677.52903-3.0387.72257-1.9871.44516-3.8452 1.96774-4.2516 4.75481-.3613 2.4904.4774 3.5613.1097 6.4581-.6452 5.058-5.4968 6.8-7.7613 7.858-1.3097.6065-4.49033 2-6.94194 3.0645 2.65806 1.9613 5.93544 3.1226 9.49034 3.1226 8.8387 0 16-7.1613 16-15.9999 0-3.7678-1.3033-7.2323-3.4839-9.96133-.0387-.00645-.0774-.0129-.1226-.01935z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.2 13.6516c1.2322-2.6645.7871-2.671 1.7226-5.1742 1.1806-3.17418 4.8516-2.27096 5.8645-2.13548 1.6709.22581 2.1097-.36774 5.6322-.93548.1742-.0258.342-.05161.5097-.07097-2.929-3.27096-7.1871-5.33547-11.929-5.33547-6.36775 0-11.86452 3.71612-14.43871 9.10321 5.27741 1.30969 10.97421 4.15479 12.63871 4.54839zm-3.4968-10.86451c.4645.07097 2.7226 2.87742 3.1484 10.08381 0 0-2.9032-.6967-3.529-2.1935-.51616-1.23226.1548-2.85161.3806-7.89031zm17.7871 3.21935c.0065.0129.0194.01936.0258.03226-.0387-.00645-.0839-.00645-.1226-.0129.0323-.01291.0645-.01291.0968-.01936zm-28.4903 9.99356c0-1.2774.148387-2.5162.432258-3.7032.580642.4838 1.200002 1.0193 1.858062 1.6322 4.16774 3.8645 10.94838 6.9161 13.41938 4.0774.0064.0065.0129.0065.0129.0129-.4516.5936-2.1742 2.471-5.4645 1.8903l-5.20004 7.7613c-3.10967-2.9161-5.05806-7.0645-5.05806-11.6709z",
    fill: "url(#b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiswap);
export default __webpack_public_path__ + "static/media/biswap.40e534712790cd0d6205580b48f3a649.svg";
export { ForwardRef as ReactComponent };